import { render, staticRenderFns } from "./WidgetPageV2.vue?vue&type=template&id=e574967a&scoped=true"
import script from "./WidgetPageV2.vue?vue&type=script&lang=js"
export * from "./WidgetPageV2.vue?vue&type=script&lang=js"
import style0 from "./WidgetPageV2.vue?vue&type=style&index=0&id=e574967a&prod&scoped=true&lang=css"
import style1 from "./WidgetPageV2.vue?vue&type=style&index=1&id=e574967a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e574967a",
  null
  
)

/* custom blocks */
import block0 from "./WidgetPageV2.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports